<template>
  <div class="capture">
    <div class="flex-c" style="border-bottom: 1px solid #ccc; margin-bottom:8px">
      <span class="margin-8">{{$t('ctcicl1')}}</span>
      <el-date-picker
        v-model="time"
        type="datetimerange"
        :picker-options="pickerOptions"
        :range-separator="$t('ctcicl2')"
        :start-placeholder="$t('ctcicl3')"
        :end-placeholder="$t('ctcicl4')"
        align="right"
        size="mini"
        class="margin-8"
        @change="changeTime"
      ></el-date-picker>
      <el-button size="mini" type="danger" @click="delCapture">{{$t('ctcicl5')}}</el-button>
      <!-- <el-input v-model="keyword" placeholder="请输入素材名称" style="width:200px" size="mini" class="margin-8"></el-input>
      <el-button type="primary" size="mini" class="margin-8">搜索</el-button>-->
    </div>
    <div class="capture-list">
      <div class="capture-item" v-for="capture in captureList" :key="capture.id">
        <img class="capture-img" :src="capture.ref_url" alt :title="capture.name" @dblclick="openMedia(capture)" />
        <el-checkbox class="checked" :class="{'checked-true':capture.checked}" v-model="capture.checked"></el-checkbox>
        <div class="ellipsis-1">{{ capture.name }}</div>
      </div>
      <i class="capture-item" style=" height: 0px;" v-for="i in 6" :key="i+'key'"></i>
    </div>
    <preview :previewData="previewData" @previewVisible="previewVisible"></preview>
  </div>
</template>

<script>
import { mPreview } from "@/components/basics/mixins"
import Preview from '@/components/basics/Preview'

export default {
  name: "CaptureList",
  mixins: [mPreview],
  props: {
    currentDetail: {
      type: Object
    }
  },
  components: {
    Preview
  },
  data() {
    return {
      deviceInfo: {},
      captureList: [],
      keyword: '',
      time: '',
      pickerOptions: {
        shortcuts: [{
          text: this.$t('ctcicl6'),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t('ctcicl7'),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t('ctcicl8'),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },
  methods: {
    changeTime(time) {
      if (!time) { return; }
      const [start, end] = time;
      this.getCaptureList(start.toLocaleString(), end.toLocaleString());
    },
    getCaptureList(startTime, endTime) {
      const { sn } = this.currentDetail;
      this.$http.post("/admin/device/getCaptureList", { device_sn: sn, startTime, endTime }, (res) => {
        this.captureList = res;
      });
    },
    delCapture() {
      const ids = this.captureList.filter((c) => c.checked).map((c) => c.id);
      if (ids.length === 0) {
        this.$msg({ message: this.$t('ctcicl9'), type: "warning", showClose: true });
        return;
      }
      this.$http.post("/admin/device/delCapture", { ids: ids.join(',') }, () => {
        this.getCaptureList();
        this.$msg({ message: this.$t('ctcicl10'), type: "success", showClose: true });
      });
    },
    openMedia(capture) {
      console.log(capture);
      const { id, ref_url } = capture;
      this.handlePreview(id, { ref_url, type: 2 });
    }
  },
  computed: {
    // myWebSocket() {
    //   return this.$store.getters.myWebSocket;
    // },
  },
  created() {
    this.getCaptureList();
  }
}
</script>

<style lang="scss" scoped>
.capture {
  width: 100%;
  height: calc(100% - 80px);
  .margin-8 {
    margin: 8px;
  }
  .capture-list {
    display: flex;
    justify-content: space-around;
    height: calc(100% - 60px);
    overflow-y: auto;
    flex-wrap: wrap;
  }

  .capture-item {
    width: 320px;
    height: 200px;
    position: relative;
    .checked {
      position: absolute;
      top: 8px;
      left: 8px;
      opacity: 0;
    }
    .checked-true {
      opacity: 1;
    }
    .capture-img {
      width: 320px;
      height: 180px;
    }
  }
  .capture-item:hover .checked {
    opacity: 1;
  }
}
</style>
